export interface HomepageFeature {
  icon: string;
  iconUrl?: string;
  imageUrl?: string;
  title: string;
  description: string;
  ctaText?: string;
  ctaUrl?: string;
}

export const HOMEPAGE_PREVIEW_STORAGE_KEY = 'hitster-homepage-preview-content';

export interface HomepageDifficulty {
  name: string;
  description: string;
  tokens: string;
}

export interface HomepageContent {
  heroTitle: string;
  tagline: string;
  introTitle: string;
  introText: string;
  featuresTitle: string;
  features: HomepageFeature[];
  difficultyTitle: string;
  difficulties: HomepageDifficulty[];
  joinTitle: string;
  joinText: string;
  joinButtonText: string;
  joinButtonUrl?: string;
  adminButtonText: string;
  footerText: string;
}

export const DEFAULT_HOMEPAGE_CONTENT: HomepageContent = {
  heroTitle: 'Ouderwetse Gezelligheid',
  tagline: 'Avondvullende programma\'s voor teams, verenigingen en events',
  introTitle: 'Wat bieden wij?',
  introText:
    'Wij organiseren complete avondprogramma\'s met quiz, muziek, spel en interactieve onderdelen. Kies een format of combineer meerdere opties tot een programma dat perfect past bij jullie groep.',
  featuresTitle: 'Mogelijkheden',
  features: [
    {
      icon: '🎵',
      title: 'Muziekquiz op maat',
      description:
        'Van hitlijsten tot thema-avonden: wij bouwen een quiz die past bij jullie publiek en sfeer.',
      ctaText: 'Bekijk opties',
    },
    {
      icon: '🎤',
      title: 'Presentatie & spelbegeleiding',
      description: 'Een enthousiaste host begeleidt de avond met energie, structuur en humor.',
      ctaText: 'Meer informatie',
    },
    {
      icon: '✨',
      title: 'Complete avondvulling',
      description:
        'Combineer meerdere rondes, mini-games en pauzemomenten tot een volwaardig programma.',
      ctaText: 'Plan jullie avond',
    },
  ],
  difficultyTitle: 'Veelgekozen formats',
  difficulties: [
    {
      name: 'Borrel & Quiz',
      description: 'Laagdrempelig, interactief en perfect voor gemengde groepen',
      tokens: '2 uur',
    },
    {
      name: 'Thema Avond',
      description: 'Volledige avond rondom een gekozen stijl, jaar of genre',
      tokens: '3 uur',
    },
    {
      name: 'Bedrijfseditie',
      description: 'Programma op maat voor teams, collega\'s en bedrijfsfeesten',
      tokens: 'Maatwerk',
    },
  ],
  joinTitle: 'Interesse in jullie eigen programma?',
  joinText: 'Neem contact op voor beschikbaarheid en een voorstel op maat.',
  joinButtonText: 'Plan een avond',
  joinButtonUrl: '/join',
  adminButtonText: '🔐 Admin Login',
  footerText: 'Ouderwetse Gezelligheid — Avondvullende concepten met muziek, quiz en beleving',
};
